export default {
    warehouse: 'المستودع',
    'material-name-or-num': 'رقم أو اسم المادة',
    'loss-ratio': 'نسبة الخياس',
    'count': 'العدد',
    'produced-quantity': 'الكمية المنتجة',
    
    'save': 'حفظ',
    'edit': 'تعديل',

    'back-to-the-bond': 'عودة للسند',
    
    'delete-raw-material': 'حذف مادة أولية',
    'are-you-sure-you-want-to-delete-the-raw-material': 'هل أنت متأكد من حذف المادة الأولية؟',

    'context-menu': {
        edit: 'تعديل',
        delete: 'حذف',
    },

    headers: {
        'no': 'الرقم',
        'warehouse': 'المستودع',
        'material': 'المادة',
        'count': 'العدد',
        'quantity': 'الكمية',
        'cost-of-one': 'كلفة الواحدة',
        'cost': 'الكلفة',
    },
    total_cost: 'إجمالي الكلفة: ',
    'product-is-updated-successfully': 'تم تحديث المنتج بنجاح'
}